import { render, staticRenderFns } from "./center.vue?vue&type=template&id=4b4e2c6c&scoped=true"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"
import style0 from "./center.vue?vue&type=style&index=0&id=4b4e2c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e2c6c",
  null
  
)

export default component.exports